import React, {useEffect, useRef, useState} from "react";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import {CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG} from "assets";
import {logoFullWhite, logoIconWhite, logoBill} from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import {payService} from "api";
import {column, getTodayString} from "./ModalPrint.config";
import {useAppSelector} from "redux/hooks";
import moment from "moment";
import "./ModalPrint.scss";
import Notification from "components/common/notification/notification";
import {ReactComponent as PhoneSVG} from "assets/icons/phone-svg.svg";
import {ReactComponent as MailSVG} from "assets/icons/mail-svg.svg";
import {ReactComponent as InternetSVG} from "assets/icons/internet-svg.svg";
import {
  birthday2Age,
  convertIosStringToDate,
  formatToCurrencyType,
  convertDateStringToDateTimezone_7,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import {HeaderPrintForm} from "components/common";
import {FORMAT_TIME} from "types/enums";
import {listPhuongThucTT} from "data/list";
const {Text} = Typography;

const ModalPrint = props => {
  const {isShowModal, handleOk, handleCancel, listId} = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [data, setData] = useState([]);
  const [dataTab, setDataTab] = useState([]);
  const idLanKham = useAppSelector(state => state.reduxCommon.id);
  const idBh = useAppSelector(state => state.common.idReceiptPrint);
  const tableThanhToan = useAppSelector(
    state => state.reduxCommon.tableThanhToan
  );
  const [thanhTien, setThanhTien] = useState();
  const [tongCong, setTongCong] = useState();
  const [tenThuNgan, setTenThuNgan] = useState<any>();

  useEffect(() => {
    getData();
    getDataInfo();
  }, [isShowModal]);
  const getData = async () => {
    // console.log('LIST ID', listId);
    const newData = {
      list_id: listId,
    };
    try {
      await payService.getDataPayPrint(newData).then(res => {
        // console.log('data in phieu thu', res);
        // setThongTinIn(res.data.data)
        console.log(res);
        const newData = res.data.data.chiDinh.map(item => ({
          noiDung: item.tenChiDinh,
          donVi: item.donVi,
          soLuong: item.soLuong,
          donGiaBV: item.donGiaBenhVien,
          donGiaBH: item.donGiaBaoHiem,
          thanhTien: item.thanhTien,
          bhChiTra: item.baoHiemChiTra,
          bnCungChiTra: item.benhNhanCungChiTra,
          bnTra: item.benhNhanTuTra,
          lyDoMienGiam: item.lyDoMienGiam,
          soTienMienGiam: item.soTienMienGiam,
        }));
        console.log("🚀 ~ newData ~ newData:", newData);
        setData(newData);
        const hinhThucTTValues = res.data.data.chiDinh.map(
          item => item.idHinhThucThanhToan
        );
        // console.log("thanh toán",hinhThucTTValues);

        setDataTab(hinhThucTTValues);
        const tenThuNganArray = res.data.data.chiDinh.map(
          item => item.tenThuNgan
        );
        const uniqueTenThuNganArray = tenThuNganArray.filter(
          (value, index, self) => {
            return self.indexOf(value) === index;
          }
        );
        if (uniqueTenThuNganArray.length == 1) {
          setTenThuNgan(tenThuNganArray[0]);
        }
        if (uniqueTenThuNganArray.length > 1) {
          setTenThuNgan("");
        }
        setThanhTien(res.data.data.thanhTien);
        setTongCong(res.data.data.tongCongBangSo);
      });
    } catch (err) {
      Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu in phiếu");
    }
  };

  const getDataInfo = async () => {
    try {
      let response = await payService
        .getDataPayPrintPerson(idLanKham)
        .then(res => {
          setThongTinIn(res.data.data);
        });
    } catch (err) {}
  };

  const onPrint = async () => {
    handleCancel();
    window.print();
  };

  const capitalizeFirstLetter = str => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getDateStringLocale = (dateString: string) => {
    const validDate = moment(dateString).isValid();
    if (validDate) {
      const date = moment(dateString);
      const day = date.date();
      const month = date.month() + 1;
      const year = date.year();
      const time = date.format("HH:mm");
      return `${time} Ngày ${day} tháng ${month} năm ${year}`;
    } else {
      return "";
    }
  };

  return (
    <Row className="exam-reg-bill" style={{fontSize: "10px"}}>
      <Modal
        wrapClassName="modal-custom-print"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={1000}
      >
        <div className="print-thanh-toan-don">
          <div ref={printRef} style={{paddingTop: "8px"}}>
            <HeaderPrintForm />
            <Row
              style={{
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              <Row justify={"center"}>
                {/* <Typography.Title 
                style={{
                  fontWeight: '700',
                  fontSize: "30px"
                }}>PHIẾU THU TIỀN</Typography.Title> */}
                <div
                  style={{
                    fontSize: "30px",
                    fontWeight: "700",
                    paddingTop: "5px",
                  }}
                >
                  PHIẾU THU TIỀN
                </div>
              </Row>
              <Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text style={{fontWeight: "800"}}>
                      {thongTinIn?.hoTen?.toUpperCase()}
                    </Typography.Text>
                    {thongTinIn?.gioiTinh
                      ? ` - ${
                          gioiTinhOptions.find(
                            it => it.value === thongTinIn?.gioiTinh
                          )?.label
                        }`
                      : ""}{" "}
                    -{" "}
                    {thongTinIn?.ngaySinh
                      ? birthday2Age(thongTinIn?.ngaySinh)
                      : ""}{" "}
                    tuổi -
                    {thongTinIn?.ngaySinh
                      ? `(SN: ${convertDateStringToDateTimezone_7(
                          thongTinIn?.ngaySinh
                        ).format(FORMAT_TIME.dayFull)})`
                      : "(SN: )"}
                    {/* {thongTinIn?.soDienThoai ? ` - ${thongTinIn.soDienThoai}` : ""} */}
                  </Col>
                  <Col>
                    <Space size={30}>
                      <Typography.Text>
                        Thời gian khám: &nbsp;
                        <Typography.Text>
                          {thongTinIn?.mgayNhapVien
                            ? dayjs(thongTinIn?.mgayNhapVien).format(
                                FORMAT_TIME.dateTime
                              )
                            : ""}
                        </Typography.Text>
                      </Typography.Text>
                      <Typography.Text>
                        Mã bệnh nhân: &nbsp;
                        <Typography.Text strong>
                          {thongTinIn?.maBenhNhan}
                        </Typography.Text>
                      </Typography.Text>
                    </Space>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text>
                      Địa chỉ: &nbsp;
                      <Typography.Text>{thongTinIn?.diaChi}</Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col
                    style={{
                      marginRight: thongTinIn?.soDienThoai ? "0px" : "90px",
                    }}
                  >
                    <Typography.Text>
                      SĐT: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.soDienThoai
                          ? ` ${thongTinIn.soDienThoai}`
                          : ""}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
              </Row>
              <Row style={{marginTop: "5px"}}>
                <Table
                  bordered
                  columns={column}
                  dataSource={data}
                  style={{width: "100%"}}
                  pagination={false}
                />
              </Row>
              <Row style={{marginTop: "5px"}}>
                <Space>
                  <Text strong>Tổng cộng :</Text>
                  <Typography.Text strong>
                    {formatToCurrencyType(tongCong)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Space>
                  <Text strong>Tổng tiền bằng chữ :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thanhTien)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Text strong>Phương thức thanh toán : &nbsp;</Text>
                <Typography.Text strong>
                  {tableThanhToan?.map(e => (
                    <Row>
                      <Typography.Text>
                        {
                          listPhuongThucTT?.find(
                            tt => tt?.value == e?.idHinhThucThanhToan
                          )?.label
                        }
                        : {formatToCurrencyTypeToFixed(e?.soTienGiaoDich)}
                      </Typography.Text>
                    </Row>
                  ))}
                </Typography.Text>
              </Row>

              {/* <Row>
                <Space>
                  <Text strong>Phương thức thanh toán :</Text>
                  <Typography.Text strong>
                    {dataTab && dataTab.length > 0 && dataTab[0] !== undefined
                      ? Array.from(
                          new Set(
                            dataTab.map(value => {
                              switch (value) {
                                case 0:
                                  return "Tiền mặt";
                                case 1:
                                  return "Chuyển khoản";
                                case 2:
                                  return "Quẹt thẻ";
                                default:
                                  return "";
                              }
                            })
                          )
                        ).join(" + ")
                      : ""}
                  </Typography.Text>
                </Space>
              </Row> */}

              <Row style={{marginTop: "0px"}}>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    style={{marginRight: "15px"}}
                  >
                    {getDateStringLocale(thongTinIn?.thoiGianThanhToan)}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người nộp tiền</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={64}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>Tên thu ngân</Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>{tenThuNgan}</Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
              <Row justify={"center"} style={{marginTop: "0px"}}>
                <Typography.Text style={{fontSize: "12px"}} strong>
                  Quý khách có nhu cầu hóa đơn VAT xin vui lòng báo lễ tân /
                  CSKH 0866.224.883 ngay trong ngày phát sinh dịch vụ, Bệnh viện
                  không hỗ trợ xuất hóa đơn VAT nếu nhận thông tin sau thời điểm
                  này. Xin cảm ơn
                </Typography.Text>
              </Row>
            </Row>
            {/* </Watermark> */}
          </div>
        </div>
        <Row justify={"end"} style={{padding: "12px", gap: "4px"}}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-thanh-toan-don"
            />
          </Space>
        </Row>
      </Modal>
    </Row>
  );
};

export default ModalPrint;
